// extracted by mini-css-extract-plugin
export default {"exportButton":"CompaniesListPage_exportButton__y0K3Z"};